import React from 'react';
import { css } from 'emotion';
import { TextArea as SourceTextArea } from '@guardian/src-text-area';
const textAreaStyles = css `
	width: 100%;
`;
export const TextArea = ({ formField, formData, setFormData }) => (React.createElement(React.Fragment, null,
    React.createElement(SourceTextArea, { "data-testid": `form-field-${formField.id}`, label: formField.label, className: textAreaStyles, optional: !formField.required, value: formField.id in formData ? formData[formField.id] : '', onChange: (e) => setFormData({
            ...formData,
            [formField.id]: e.target.value,
        }) })));
